import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StyledButtonV2 from "../../../../components/app/StyledButtonV2";
import { NAVBAR } from "../../../../utils/utils";
import { INVOICE_TYPE_OPTIONS, InvoiceType } from "./billing-constant";

// ECRH-5347: "Create Invoice" now opens a dropdown so the user picks the
// invoice type (Self Pay / Out of Network / Patient Responsibility) up front.
// The selection is forwarded to the Create Invoice form via the `invoiceType`
// query param and ultimately posted with the SuperBill.
const CreateInvoiceTypeMenu = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleSelect = (invoiceType: InvoiceType) => {
    setAnchorEl(null);
    navigate(`add-invoice?invoiceType=${invoiceType}`);
  };

  return (
    <>
      <StyledButtonV2
        label={"Create Invoice"}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        shouldAddIcon
        eIcon={<KeyboardArrowDownIcon />}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {INVOICE_TYPE_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleSelect(option.value)}
            sx={{ fontSize: NAVBAR.MENU_ITEM_FONT_SIZE }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CreateInvoiceTypeMenu;
